import {
  Box,
  Image,
  InAppSearchBox,
  Typography,
  useTheme
} from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { searchPath } from "@outschool/routes";
import { TrustpilotMicroCombo } from "@outschool/ui-components-website";
import {
  Container,
  CurvedTopper
} from "@outschool/ui-legacy-component-library";
import {
  responsive,
  useIsMobile,
  useLinkComponent,
  useNavigation
} from "@outschool/ui-utils";
import React, { Fragment } from "react";

import womenImg from "../../../images/tutoring/woman-header-tutoring.png";
import { SearchFiltersContextProvider } from "../../lib/useSearchFilters";
import DesktopSearchField from "../search/desktop/DesktopSearchField";
import HeaderTitle from "./HeaderTitle";
import { usePopularSearches } from "./hooks/useTutoringPageQuery";

function HeroSection() {
  const Link = useLinkComponent();
  const theme = useTheme();
  const isMobile = useIsMobile();

  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\HeroSection"
  );
  const nav = useNavigation();
  const { topics, loading } = usePopularSearches();

  const bgColor = theme.palette.primary[50];
  return (
    <Box sx={{ marginBottom: "5rem" }}>
      <Container
        backgroundColor={bgColor}
        sx={{
          position: "relative",
          display: "grid",
          gridTemplateAreas: responsive({
            default: `"image" "text"`,
            medium: `"text image"`
          }),
          gridTemplateColumns: responsive({
            default: "100%",
            medium: "3fr 1fr"
          }),
          gap: responsive({ default: "medium", medium: "xlarge" }),
          alignItems: "center",
          paddingTop: "5rem",
          paddingBottom: "2.5rem",
          [theme.breakpoints.down("md")]: {
            paddingLeft: "1rem",
            paddingRight: "1rem"
          }
        }}
      >
        <Box
          flex
          sx={{
            gridArea: "text",
            flexDirection: "column",
            gap: "1em",
            alignItems: "center",
            [theme.breakpoints.up("md")]: {
              alignItems: "start",
              textAlign: "left"
            },
            width: "auto",
            textAlign: "center"
          }}
        >
          <HeaderTitle />
          <TrustpilotMicroCombo
            sx={{
              [theme.breakpoints.down("md")]: {
                margin: 0,
                transform: "scale(0.8)",
                width: "135%"
              }
            }}
          />

          <Box sx={{ flexDirection: "column", width: "100%" }}>
            <SearchFiltersContextProvider>
              <DesktopSearchField
                searchFilters={{}}
                setImplicitSearchFilters={() => {}}
                setSearchFilters={filters => {
                  nav(searchPath({ capacityMax: 1, ...filters }));
                }}
                clearDropdowns={() => {}}
                searchPlaceholder={t("Search any topic or teacher")}
                searchLabel={t("Find tutoring")}
                SearchBoxComponent={InAppSearchBox}
                showSearchSuggestions={false}
                menuStyleSx={{
                  top: isMobile ? "48px" : "68px"
                }}
              />
            </SearchFiltersContextProvider>
            {!loading && !!topics?.length && (
              <Typography variant="body2">
                {t("Popular searches now: ")}
                {topics.map((topic, index) => (
                  <Fragment key={`${topic}-${index}`}>
                    {!!topic?.text && !!topic?.pathB && (
                      <Fragment key={topic.text}>
                        {index > 0 && ", "}
                        <Link to={topic?.pathB}>{topic.text}</Link>
                      </Fragment>
                    )}
                  </Fragment>
                ))}
              </Typography>
            )}
          </Box>
        </Box>
        <Image
          sx={{
            width: 368,
            height: 280,
            margin: "0 auto"
          }}
          src={womenImg}
        />
      </Container>
      <CurvedTopper color={bgColor} inverted />
    </Box>
  );
}

export default HeroSection;
